import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import constants
import { IS_MOBILE } from "../../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../common/base-button/base-button";
import BaseTitle from "../../../common/base-title/base-title";

//import images and icons
import Icon from "../../../common/base-icon/icon";
import { Add, User } from "iconsax-react";

//import styles
import "./user-information.scss";

function UserInformation({ information, onSubmitImage, profileError }) {
    const profileImageRef = useRef();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //set user information
    const [userInformation, setInformation] = useState();
    useEffect(() => {
        if (information) {
            setInformation(information);
        }
    }, [information]);

    //change profile image
    const [profileImage, setProfileImage] = useState();
    useEffect(() => {
        if (!!userInformation?.avatar) setProfileImage("https://api.atripa.ir" + userInformation?.avatar);
    }, [userInformation]);

    const chooseImage = () => {
        const file = profileImageRef.current.files[0];
        onSubmitImage(file);
        if (file && !profileError) setProfileImage(URL.createObjectURL(file));
    };

    //navigate to walllet
    const goToWallet = () => {
        navigate(`/${locale}/user-panel/wallet`);
    };

    return (
        <Grid className="user-information" container item xs={12} rowGap={5}>
            {!IS_MOBILE && <BaseTitle title={t("userDetails")} dividerColor="1px solid var(--medium-gray-color)" />}

            <Grid container item xs={12} rowGap={2} columnGap={{ xs: 3, md: 5 }} alignItems="center">
                <Grid className="user-information__user-img" container item xs={3} md={1.5}>
                    <label onClick={() => profileImageRef.current.click()}>
                        {!!userInformation?.avatar || !!profileImage ? (
                            <img src={profileImage} alt="folder" />
                        ) : (
                            <User size="32" color="var(--gray-color)" variant="Bold" />
                        )}
                    </label>
                    <input id="avatar123" type="file" onChange={() => chooseImage()} hidden ref={profileImageRef} />
                </Grid>

                <Grid container item xs={7} lg={7} rowGap={{ xs: 1, md: 2 }} alignItems="center">
                    <Grid className="user-information__user-info" component="span" item xs={12}>
                        {userInformation?.first_name} {userInformation?.last_name}
                    </Grid>
                    <Grid className="user-information__user-info" component="span" item xs={12}>
                        {userInformation?.registered_with_email ? userInformation?.email : userInformation?.username}
                    </Grid>
                    <Grid className="user-information__user-type" component="span" container item xs="auto" alignItems="center">
                        <Icon name="UserTypeIcon" width="1.5rem" />
                        {t("normalUser")}
                    </Grid>
                </Grid>

                <Grid
                    className="user-information__balance-information"
                    container
                    item
                    md={2.5}
                    rowGap={3}
                    justifyContent="space-between"
                    display="none"
                >
                    <Grid
                        className="user-information__balance"
                        container
                        item
                        xs={5}
                        md={12}
                        direction={{ xs: "column", md: "row" }}
                        justifyContent="space-between"
                    >
                        <span>{t("accountBalance")}:</span>
                        <span>
                            {userInformation?.balance} {t("currency")}
                        </span>
                    </Grid>
                    <Grid container item xs={5} md={12}>
                        <BaseButton
                            text={t("depositIncrement")}
                            color="primary"
                            size="medium"
                            radius="radius-10"
                            rightIcon={<Add color="var(--light-color)" />}
                            handleClick={goToWallet}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default UserInformation;
